import { render, staticRenderFns } from "./addbehavioral.vue?vue&type=template&id=68437e8e&scoped=true&"
import script from "./addbehavioral.vue?vue&type=script&lang=js&"
export * from "./addbehavioral.vue?vue&type=script&lang=js&"
import style0 from "./addbehavioral.vue?vue&type=style&index=0&id=68437e8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68437e8e",
  null
  
)

export default component.exports